import axios from 'axios'
import { AUTH_TOKEN_KEY, GUEST_TOKEN_KEY } from 'hooks/token/useToken'

import { attachToken, handleError } from './axiosInterceptors'

const API_BASE = '/api/v1'

export const unauthorizedClient = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-type': 'application/json' },
})

unauthorizedClient.interceptors.request.use(
    attachToken(() => localStorage.getItem(GUEST_TOKEN_KEY) || localStorage.getItem(AUTH_TOKEN_KEY)),
    Promise.reject,
)
unauthorizedClient.interceptors.response.use((res) => res, handleError)
